import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { useDateFns, useNavigation, useProvider } from '~/Hooks';
import { MappingStatus } from '~/Models/DTO/Location.models';
import { selectLoading } from '~/store/app';
import { selectEventById } from '~/store/events';
import {
  requestProviderLocationsList,
  requestProviderTrainerList,
  selectLocationById,
  selectLocationList,
  selectTrainersById,
} from '~/store/provider';
import { selectEventGroup } from '~/store/eventGroups';

export const useEventPageFloatingPanel = () => {
  // hooks
  const dispatch = useDispatch();
  const { getParams } = useNavigation();
  const { id } = getParams();
  const { formatDate } = useDateFns();
  const { currentProvider } = useProvider();

  // selectors
  const selectedEvent = useSelector(selectEventById(id || ''));
  const locations = useSelector(selectLocationList);
  const trainers = useSelector(selectTrainersById(selectedEvent?.trainerIds ?? []));
  const location = useSelector(selectLocationById(selectedEvent?.locationId ?? ''));
  const eventGroup = useSelector(selectEventGroup(selectedEvent?.eventGroupId));
  const isTrainersLoading = useSelector(selectLoading(REQUEST_ACTIONS.TRAINER_LIST));
  const isLocationLoading = useSelector(selectLoading(REQUEST_ACTIONS.LOCATION_LIST));

  // actions
  const loadLocations = bindActionCreators(requestProviderLocationsList, dispatch);
  const loadTrainers = bindActionCreators(requestProviderTrainerList, dispatch);

  // const
  const startTime = selectedEvent ? formatDate(selectedEvent.start, 'H:mm') : '0:00';
  const endTime = selectedEvent ? formatDate(selectedEvent.end, 'H:mm') : '0:00';
  const eventDate = selectedEvent ? formatDate(selectedEvent.start, 'dd.MM') : '01.01';
  const eventDateTime =
    selectedEvent.type === 'FreeTraining' ? eventDate : `${eventDate}, ${startTime}-${endTime}`;

  //Loads locations and trainers if none have been found
  useEffect(() => {
    if (currentProvider) {
      if (locations.length === 0 && !isLocationLoading) {
        loadLocations(currentProvider?.uuid);
      }

      if (trainers.length === 0 && !isTrainersLoading) {
        loadTrainers(currentProvider?.uuid);
      }
    }
  }, []);

  return {
    cancelled: selectedEvent ? selectedEvent.cancelled : false,
    hasLiveStream: selectedEvent?.livestream,
    eventDate: eventDateTime,
    mappingStatus: location?.mappingStatus || MappingStatus.Unmapped,
    bookingGroups: eventGroup?.bookingGroupIds,
  };
};
